module.exports = __webpack_public_path__ + "img/Flag_of_East_Timor.7a4f9c96.svg";